import { render, staticRenderFns } from "./competeEventsList.vue?vue&type=template&id=2622f933&"
import script from "./competeEventsList.vue?vue&type=script&lang=js&"
export * from "./competeEventsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports